import { render, staticRenderFns } from "./ParticaTree.vue?vue&type=template&id=25546404&scoped=true&"
import script from "./ParticaTree.vue?vue&type=script&lang=ts&"
export * from "./ParticaTree.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaTree.vue?vue&type=style&index=0&id=25546404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25546404",
  null
  
)

export default component.exports